import React, { useState } from 'react';
import { Search, Menu, X } from 'lucide-react';
import { motion } from 'framer-motion';

const Header = ({ searchQuery, setSearchQuery }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  return (
    <header className="bg-white dark:bg-slate-800 sticky top-0 z-50 border-b border-slate-200 dark:border-slate-700 backdrop-blur-md bg-opacity-80 dark:bg-opacity-80">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
        <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="hidden md:flex items-center space-x-6"
    >
      <a href="/home" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Home</a>
      <a href="/articles" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Articles</a>
      
      <div className="relative group">
        <a
          href="/categories"
          className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors flex items-center"
        >
          Categories
          <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </a>
        <div className="absolute left-0 mt-2 w-48 bg-white dark:bg-slate-800 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
          <div className="py-1 border border-slate-200 dark:border-slate-700 rounded-md">
            <a href="/categories/development" className="block px-4 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700">Development</a>
            <a href="/categories/design" className="block px-4 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700">Design</a>
            <a href="/categories/technology" className="block px-4 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700">Technology</a>
            <a href="/categories/tutorials" className="block px-4 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700">Tutorials</a>
          </div>
        </div>
      </div>

      <a href="/archives" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Archives</a>
    </motion.nav>
          
          <div className="flex items-center space-x-4">
            <motion.div 
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="relative hidden md:block"
            >
              <input
                type="text"
                placeholder="Search posts..."
                className="w-full pl-10 pr-4 py-2 border border-slate-200 dark:border-slate-700 rounded-full bg-slate-50 dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-600 transition-all"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
            </motion.div>
            
            {/* Mobile Menu Button */}
            <motion.button
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.4 }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </motion.button>
          </div>
        </div>
        
        {/* Mobile Menu with Blog-specific Links */}
        {isMenuOpen && (
          <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="md:hidden mt-4 pb-4"
        >
          <nav className="flex flex-col space-y-4">
            <a href="/home" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Home</a>
            <a href="/articles" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Articles</a>
            
            <div className="space-y-2">
              <p className="font-medium text-indigo-600 dark:text-indigo-400">Categories</p>
              <div className="pl-4 flex flex-col space-y-2">
                <a href="/categories/development" className="text-sm hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Development</a>
                <a href="/categories/design" className="text-sm hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Design</a>
                <a href="/categories/technology" className="text-sm hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Technology</a>
                <a href="/categories/tutorials" className="text-sm hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Tutorials</a>
              </div>
            </div>
        
            <a href="/archives" className="font-medium hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">Archives</a>
            
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="Search posts..."
                className="w-full pl-10 pr-4 py-2 border border-slate-200 dark:border-slate-700 rounded-full bg-slate-50 dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-600 transition-all"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
            </div>
          </nav>
        </motion.div>
        
        )}
      </div>
    </header>
  );
};

export default Header;